var _excluded = ["allowedCountries", "setAddress", "setErrors", "config"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback } from 'react';
import { Box } from '@mediahuis/chameleon-react';
import SelectCountry from './SelectCountry';
import BelgianAddressFields from './BelgianAddressFields';
import DefaultAddresFields from './DefaultAddresFields';
import DutchAddressFields from './DutchAddressFields';
import addressFieldsValidations from './addressFieldsValidations';
/**
 * @param allowedCountries
 * @param setAddress
 * @param setErrors
 * @param {SRConfig} config
 * @param props
 * @return {JSX.Element}
 * @constructor
 */

var AddressFields = function AddressFields(_ref) {
  var allowedCountries = _ref.allowedCountries,
      setAddress = _ref.setAddress,
      setErrors = _ref.setErrors,
      config = _ref.config,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var handleAddressChange = useCallback(function (data) {
    return setAddress(function (state) {
      return _extends({}, state, data);
    });
  }, [setAddress]);

  var clearError = function clearError(e) {
    var spreadedErrors = _extends({}, props.errors);

    delete spreadedErrors[e.target.id];
    setErrors(spreadedErrors);
  };

  var clearFields = function clearFields() {
    var fields = ['houseNumber', 'box', 'street', 'city', 'postalCode'];

    var spreadedState = _extends({}, props.address);

    fields.forEach(function (field) {
      spreadedState[field] = '';
    });
    handleAddressChange(spreadedState);
  };

  var validateOnBlur = function validateOnBlur(e) {
    try {
      var _addressFieldsValidat;

      return Promise.resolve(addressFieldsValidations((_addressFieldsValidat = {}, _addressFieldsValidat[e.target.id] = e.target.value, _addressFieldsValidat), props.address.countryCode)).then(function (addressErrors) {
        setErrors(function (prevState) {
          return _extends({}, prevState, addressErrors);
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var getCountryAddressField = function getCountryAddressField() {
    switch (props.address.countryCode) {
      case 'BE':
        return /*#__PURE__*/React.createElement(BelgianAddressFields, _extends({}, props, {
          clearFields: clearFields,
          handleAddressChange: handleAddressChange,
          clearError: clearError,
          validateOnBlur: validateOnBlur,
          config: config
        }));

      case 'NL':
        return /*#__PURE__*/React.createElement(DutchAddressFields, _extends({}, props, {
          clearFields: clearFields,
          handleAddressChange: handleAddressChange,
          clearError: clearError,
          validateOnBlur: validateOnBlur,
          config: config
        }));

      default:
        return /*#__PURE__*/React.createElement(DefaultAddresFields, _extends({}, props, {
          clearFields: clearFields,
          handleAddressChange: handleAddressChange,
          clearError: clearError,
          validateOnBlur: validateOnBlur
        }));
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    mb: 4
  }, /*#__PURE__*/React.createElement(SelectCountry, {
    address: props.address,
    handleAddressChange: handleAddressChange,
    allowedCountries: allowedCountries,
    setErrors: setErrors,
    errors: props.errors,
    config: config
  })), getCountryAddressField());
};

export default AddressFields;